import { create } from "zustand";

export type SequenceCreateMode = "simple" | "fasta" | "accession";

type SequenceCreateStore = {
  open: boolean;
  mode: SequenceCreateMode;
  openDialog: (mode: SequenceCreateMode) => void;
  closeDialog: () => void;
};

export const useSequenceCreateStore = create<SequenceCreateStore>((set) => ({
  open: false,
  mode: "simple",

  openDialog(mode) {
    set({ open: true, mode });
  },

  closeDialog() {
    set({ open: false, mode: "simple" });
  },
}));
